export const START_AT_EVENING = 'START_AT_EVENING';
export const END_AT_MORNING = 'END_AT_MORNING';

export type HalfDay = typeof START_AT_EVENING | typeof END_AT_MORNING;
